import CloseIcon from "@mui/icons-material/Close";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import axios from "axios";
import React, { useRef, useEffect, useState } from "react";

import {
  customUploadDocUrlViaCamunda,
  serverBPM,
} from "../../../api/constants";
import DocumentScanning from "../../../components/DocumentScanning";
import { themeOptions } from "../../../theme/materialTheme";

const iframeUrl = `/api/smartbpm/public/v1/redirect-manager/form?no-cache=${new Date().getTime()}`;

const IframeForm = ({
  userDataLoading,
  userData,
  formData,
  onSubmit,
  taskId = "",
  history,
  previewMode = false,
}) => {
  const { form, isSignatureTask, variables } = formData;
  const ref = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [showLoading, setShowLoading] = useState(true);
  const [iframeHeigth, setIframeHeigth] = useState("99%");
  const [currentDocument, setCurrentDocument] = useState(null);
  const [openDigitalize, setOpenDigitalize] = useState(false);
  const [finalUrl, setFinalUrl] = useState("");

  const handleCloseDigitalize = () => {
    setOpenDigitalize(false);
  };

  function handleIframeEvent({ data }) {
    if (data.status === "load_complete") {
      setIsLoading(false);
    }
    if (data.size) {
      setIframeHeigth(data.size);
    }
    if (data.message === "openDocument") {
      setCurrentDocument(data.document);
    }
    if (data.message === "cancel") {
      Boolean(Object.keys(history)) && history.push("/process/all-tasks/");
    }
    if (data.message === "submit") {
      onSubmit(data.data, isSignatureTask);
    }
    if (data.message === "digitalize") {
      setOpenDigitalize(true);
    }
    if (data.error) {
      console.log(data.error);
    }
  }

  useEffect(() => {
    window.addEventListener("message", handleIframeEvent);
    return () => {
      window.removeEventListener("message", handleIframeEvent);
    };
  }, [isSignatureTask]);

  const fetch = async () => {
    try {
      const baseUrl = sessionStorage.getItem("baseUrl");

      const { request } = await axios.get(baseUrl + iframeUrl);
      setFinalUrl(request.responseURL);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    void fetch();
  }, []);

  useEffect(() => {
    if (!finalUrl) return;
    if (!ref?.current) {
      return;
    }

    if (!previewMode) {
      if (userDataLoading !== false || isLoading || !formData.form.length) {
        return;
      }

      ref.current.contentWindow.postMessage(
        {
          message: "setup",
          data: {
            uploadFileUrl:
              window.location.origin + serverBPM + customUploadDocUrlViaCamunda,
            getDocumentUrl:
              window.location.origin +
              "/api/documentos/files/{fileUid}/generate-temporary-link",
            email: userData.data.email,
            tenant: sessionStorage.getItem("tenant"),
            token: sessionStorage.getItem("token"),
            viewBox: ref.current.getBoundingClientRect(),
            taskId,
            theme: themeOptions,
            dataListUrl:
              window.location.origin +
              serverBPM +
              "/smartbpm/v1/{tenant}/data-list/{dataListId}/items/all",
            previewMode,
          },
        },
        finalUrl,
      );
    }

    ref.current.contentWindow.postMessage(
      {
        message: isSignatureTask ? "signature" : "task",
        data: { variables, form, previewMode },
      },
      finalUrl,
    );

    ref.current.contentWindow.postMessage(
      {
        message: "isSmartdocs",
      },
      finalUrl,
    );
    setShowLoading(false);
  }, [ref, isLoading, userDataLoading, formData, userData, finalUrl]);

  const handleModalClose = () => {
    setCurrentDocument(null);
  };

  const handleChange = (files) => {
    ref.current.contentWindow.postMessage(
      {
        message: "digitalizeUpload",
        data: { file: files[0] },
      },
      iframeUrl,
    );
    handleCloseDigitalize();
  };

  return (
    <>
      {showLoading && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      )}
      <Box
        component="iframe"
        ref={ref}
        src={finalUrl}
        sx={{
          width: "100%",
          height: iframeHeigth,
          border: "none",
          overflow: "hidden",
          display: showLoading ? "hidden" : "unset",
        }}
        scrolling="no"
      />
      {currentDocument && (
        <Dialog
          fullScreen
          onClose={handleModalClose}
          open={open}
          sx={{ "& > div > div": { backgroundColor: "#dadada !important" } }}
        >
          <AppBar>
            <Toolbar>
              <IconButton
                aria-label="close"
                color="inherit"
                edge="start"
                onClick={handleModalClose}
              >
                <CloseIcon />
              </IconButton>
              <Typography>{currentDocument.fileName}</Typography>
            </Toolbar>
          </AppBar>
          <Toolbar />
          {currentDocument.type === "application/pdf" ? (
            <iframe
              height="100%"
              src={`https://docs.google.com/viewer?url=${currentDocument.fileUrl}&embedded=true`}
              style={{
                border: "none",
              }}
              title="file"
              width="100%"
            />
          ) : (
            <img
              src={currentDocument.fileUrl}
              style={{
                maxWidth: "90%",
                boxShadow: "0px 0px 7px #9b9b9b",
                margin: "auto",
              }}
            />
          )}
        </Dialog>
      )}
      {openDigitalize && (
        <DocumentScanning
          handleClose={handleCloseDigitalize}
          handleSave={(file) => handleChange([file])}
          handleCancel={handleCloseDigitalize}
        />
      )}
    </>
  );
};

export default IframeForm;
